/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function () {
  angular.module('cbl.telepass.wa').service('TlpsPropostaSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    '$state',
    '$stateParams',
    function ($http, messaggiFctr, CONSTANTS, labelSrvc, $state, $stateParams, $scope) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.$state = $state;
      this.$stateParams = $stateParams;

      // Variabili generali pratica
      this.datiCliente = null;
      this.idPratica = null;
      this.datiPratica = undefined;
      this.datiProdotto = null;

      this.isCancelEnabled = null;
      this.isSaveEnabled = null;
      this.isPrevEnabled = null;
      this.isNextEnabled = null;
      this.isCompleteEnabled = null;
      this.datiValidi = null;
      this.apparatoAggiuntivo = false;

      // Spinner
      this.spinner = { showSpinner: false };

      var self = this;

      /**
       * Flag che indica se tutti i documenti sono stati firmati
       */
      this.documentiFirmati = false;


      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseCreaPratica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per creare la pratica
       * @return {Promise} - Ritorna una promise contenente l'id della pratica appena creata
       */
      this.promiseCreaPratica = function (request) {
        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.CREA_PRATICA,
          data: request
        });
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per aggiornare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente il dettaglio della pratica
       */
      this.promiseAggiornaPraticaAvanti = function (idPratica, datiPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica + '/avanti',
          data: datiPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per aggiornare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente il dettaglio della pratica
       */
      this.promiseAggiornaPraticaIndietro = function (idPratica, datiPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica + '/indietro',
          data: datiPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per aggiornare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente il dettaglio della pratica
       */
      this.promiseAggiornaPraticaSalva = function (idPratica, datiPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica,
          data: datiPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseAnnullaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per annullare e cancellare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseAnnullaPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.ANNULLA_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRifiutaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRifiutaPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RIFIUTA_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRisottomettiPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRisottomettiPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RISOTTOMETTI_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseCompletaProposta
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per completare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con l'esito del completamento
       */
      this.promiseCompletaProposta = function (idPratica, ndg) {
        var qryParams = {
          idPratica: idPratica,
          ndg: ndg
        };

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.COMPLETA_PRATICA,
          data: {},
          params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagrafica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli dell'anagrafica
       * @return {Promise} - Ritorna una promise contenente l'anagrafica
       */
      this.promiseRecuperaAnagrafica = function (ndg) {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.RECUPERA,
          params: { ndg: ndg }
        });
      };

      this.promiseRecuperaContrattiCliente = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA_CONTRATTI_CLIENTE + ndg
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaOpzioniTelepass
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare gli opzioni telepass
       * @return {Promise} - Ritorna una promise contenente le opzione di telepass
       */
      this.promiseRecuperaOpzioniTelepass = function (codProdotto) {
        var qryParams = {
          canale: 'BRIO_FILIALE',
          prodotto: codProdotto
        };
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CONFIGURAZIONI.RECUPERA_OPZIONI_TELEPASS,
          data: {},
          params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name promiseVerificaPromozioni
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per verificare se ci sono codicie promozione disponibili
       * @return {Promise} - Ritorna una promise se ci sono codici promozione
       */
      this.promiseVerificaPromozioni = function () {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CONFIGURAZIONI.VERIFICA_PROMOZIONI
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioProdotto
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli del prodotto
       * @return {Promise} - Ritorna una promise contenente i dettagli del prodotto
       */
      this.promiseDettaglioProdotto = function (idProdotto) {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRODOTTO.DETTAGLIO_PRODOTTO + idProdotto
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli della pratica
       * @return {Promise} - Ritorna una promise contenente i dettagli della pratica
       */
      this.promiseDettaglioPratica = function (idPratica, ndg) {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name goToSchedaCliente
       * @methodOf cbl.telepass.wa.directive:tlpsProposta
       * @description Ridireziona verso la scheda del cliente
       */
      this.goToSchedaCliente = function () {
        self.datiProdotto = null;
        self.datiPratica = null;
        self.datiCliente = null;
        self.$state.go('schedaCliente', { ndg: self.$stateParams.ndg });
      };

      /*
       * -------------------------------------
       *        GESTIONE NAVIGAZIONE
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name isPraticaNavigabile
       * @methodOf cbl.telepass.wa.directive:tlpsProposta
       * @description Verifica se la pratica non è in stato INCORSO o CONSOLIDATA, e quindi navigabile
       * @return {Boolean} - True se la pratica è navigabile, false in caso contrario
       */
      this.isPraticaNavigabile = function () {
        if (!self.datiPratica) {
          return false;
        }
        return (
          self.datiPratica &&
          self.datiPratica.stato &&
          self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.IN_CORSO &&
          self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.CONSOLIDATA &&
          self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.DAREVISIONARE
        );
        // return true;
      };

      /**
       * @ngdoc method
       * @name isProseguiVisible
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Verifica se il tasto prosegui è visibile
       * @return {Boolean} - True se il tasto è visibile, false in caso contrario
       */
      this.isProseguiVisible = function () {
        if (!self.datiPratica) {
          return true;
        }

        // Il tasto prosegui è visibile solo se siamo in stato INCORSO o CONSOLIDATA 3
        return (
          self.datiPratica.pratica &&
          self.datiPratica.pratica.stato &&
          (self.datiPratica.pratica.stato === CONSTANTS.STATO_PRATICA.IN_CORSO ||
            (self.datiPratica.pratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA &&
              self.datiPratica.pratica.step !== 3))
        );
      };

      this.isCompletaAbilitato = function() {
        return self.getIsStatoCorretto() && self.documentiFirmati;
      };

      this.getIsStatoCorretto = function() {
        return (
            self.datiPratica &&
            ((self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 3) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 6) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 1) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 2) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 3))
        );
      };


      /**CAMBIARE A DefinizioneSrvc
       * @ngdoc method
       * @name promiseRecuperaContiCorrenti
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i conti correnti dell'ndg
       * @return {Promise} - Ritorna una promise contenente la lista dei conti correnti
       */
      this.promiseRecuperaContiCorrenti = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CONTOCORRENTE.RICERCA_CONTICORRENTE,
          params: { ndg: ndg }
        });
      };

      this.indietro = function () {
        self.messaggiFctr.resetMessages();

        var pratica = self.buildRequestObject();

        self.pulisciDati(pratica);

        self.spinner.showSpinner = true;

        self
          .promiseAggiornaPraticaIndietro(pratica.idPratica, pratica)
          .then(
            function (response) {
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.datiPratica = response.data.result;
                self.$stateParams.idPratica = self.idPratica = response.data.result.idPratica;

                if (self.datiPratica.settore === 'VIACARD') {
                  self.datiPratica.modalitaRitiro = {
                    codice: 'S'
                  };
                }
                self.generaTabs();
              }
            },
            function (error) {
              if (self.messaggiFctr.processaResponse(error)) {
                self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      };

      this.pulisciDati = function (pratica) {
        // Se il prodotto è viacard elimino i dati non necessari
        if (pratica.settore === 'VIACARD') {
          delete pratica.modalitaRitiro;
          delete pratica.opzione;
          delete pratica.codicePromozione;
          delete pratica.twin;
          delete pratica.targa;
          delete pratica.nazioneTarga;
          delete pratica.targaTwin;
          delete pratica.nazioneTargaTwin;
          delete pratica.codiceApparatoTwin;
        }

        if (pratica.settore === 'TELEPASS') {
          delete pratica.numeroCarte;
        }
      };

      /**
       * @ngdoc method
       * @name save
       * @methodOf cbl.telepass.wa:CcpropostaTelepassSrvc
       * @description Esegue le chiamate per salvare la pratica se già esiste altrimenti quella per crearla.
       */
      this.salva = function () {
        self.messaggiFctr.resetMessages();
        if (!self.datiValidi()) {
          return;
        }
        var pratica = self.buildRequestObject();

        self.pulisciDati(pratica);

        self.spinner.showSpinner = true;

        self
          .promiseAggiornaPraticaSalva(self.idPratica, pratica)
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.spinner.showSpinner = false;
                return;
              }
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.datiPratica = response.data.result;
                self.$stateParams.idPratica = self.idPratica = response.data.result.idPratica;

                if (self.datiPratica.settore === 'VIACARD') {
                  self.datiPratica.modalitaRitiro = {
                    codice: 'S'
                  };
                }
                // Aggiorno i parametri nella URL per poterli mettere a disposizione anche degli altri componenti
                self.$state.go('.', self.idPratica);
                self.generaTabs();
              }
            },
            function (error) {
              if (self.messaggiFctr.processaResponse(error)) {
                self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      };

      this.salvaAvanza = function () {
        var pratica = self.buildRequestObject();

        self.pulisciDati(pratica);

        self.spinner.showSpinner = true;

        self
          .promiseAggiornaPraticaAvanti(pratica.idPratica, pratica)
          .then(
            function (response) {
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.datiPratica = response.data.result;
                self.$stateParams.idPratica = self.idPratica = response.data.result.idPratica;

                if (self.datiPratica.settore === 'VIACARD') {
                  self.datiPratica.modalitaRitiro = {
                    codice: 'S'
                  };
                }

                if (
                  self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.IN_CORSO &&
                  self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.CONSOLIDATA
                ) {
                  var message = {};
                  message.type = 'I';
                  message.message = self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA ? 'Pratica presentata' :
                      'Pratica completata con successo. La pratica è in stato di valutazione in attesa di esito da parte di Telepass';
                  messaggiFctr.addMessage(message);
                  self.goToSchedaCliente();
                } else {
                  self.$state.go('.', self.idPratica);
                  self.generaTabs();
                }
              }
            },
            function (error) {
              if (self.messaggiFctr.processaResponse(error)) {
                self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      };

      this.avanza = function () {
        self.messaggiFctr.resetMessages();
        if (self.datiValidi()) {
          self.salvaAvanza();
        }
      };

      this.buildRequestObject = function () {
        if (self.datiPratica.settore === 'TELEPASS') {
          self.datiPratica.class = 'PraticaTelepassDto';
          self.datiPratica.opzione = JSON.parse(self.datiPratica.opzione);
        } else if (self.datiPratica.settore === 'VIACARD') {
          self.datiPratica.class = 'PraticaViacardDto';
        }
        if (self.datiPratica.dataSottoscrizioneContratto) {
          self.datiPratica.dataSottoscrizioneContratto = new Date(
            self.datiPratica.dataSottoscrizioneContratto
          ).toLocaleDateString();
        }
        return {
          idPratica: self.datiPratica.idPratica,
          class: self.datiPratica.class,
          specializzazione: self.datiPratica.specializzazione,
          numeroCarte: self.datiPratica.numeroCarte,
          intestatario: {
            ndg: self.datiCliente.ndg
          },
          ndgReferente: self.datiPratica.ndgReferente,
          stato: self.datiPratica.stato,
          inserimento: self.datiPratica.inserimento,
          step: self.datiPratica.step,
          prodotto: self.datiProdotto,
          workflow: 'ACQUISTO_BRIO',
          settore: self.datiPratica.settore,
          numeroRapporto: self.datiPratica.numeroRapporto,
          opzione: self.datiPratica.opzione,
          codicePromozione: self.datiPratica.codicePromozione,
          twin: self.datiPratica.twin,
          modalitaRitiro: self.datiPratica.modalitaRitiro,
          datiSpedizione: self.datiPratica.datiSpedizione,
          targa: self.datiPratica.targa,
          nazioneTarga: self.datiPratica.nazioneTarga,
          targaTwin: self.datiPratica.targaTwin,
          nazioneTargaTwin: self.datiPratica.nazioneTargaTwin,
          questionarioPraticaList: self.datiPratica.questionarioPraticaList,
          codiceApparato: self.datiPratica.codiceApparato,
          codiceApparatoTwin: self.datiPratica.codiceApparatoTwin,
          dataSottoscrizioneContratto: self.datiPratica.dataSottoscrizioneContratto
        };
      };

      /**
       * @ngdoc method
       * @name formattazioneData
       * @methodOf cbl.telepass.wa:CcpropostaTelepassSrvc
       * @description Formatta la data per visualizzarla
       */
      this.formattazioneData = function (data) {
        if (!data) {
          return '';
        }

        var giorno = data.dayOfMonth;
        var mese = data.monthValue;
        var anno = data.year;

        return giorno + '/' + mese + '/' + anno;
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsProposta/tlpsPropostaSrvc.js
// module id = 34
// module chunks = 0